var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',[_vm._v("Delete Account")]),_c('p',{staticClass:"px-5"},[_vm._v("You will receive an email to confirm deletion of the account.")]),_c('button',{staticClass:"btn-danger border-0 p-2 pl-5 pr-5",attrs:{"type":"button"},on:{"click":_vm.deleteHandler}},[_vm._v("Delete My Account")])])
}
var staticRenderFns = []

export { render, staticRenderFns }